import axios from 'axios';
import { cloneDeep, capitalize } from 'lodash';

import appConfig from '@/configs/app.config';
import { isMobilePhone } from '@/libs/utils';
import { CUSTOMER_SEX_TYPES, CUSTOMER_TYPES, PAYMENT_TYPES } from '@/modules/constants';

const BREAKPOINT_MOBILE = 800;

const initialState = {
  step: 1,
  selectionPopup: false,
  selectionPopupItems: [],
  selectionPopupZipId: null,
  selectionPopupZipIdSecond: null,
  selectionPopupLevel: 1,
  selectionZipCodeFirst: null,
  selectionZipCodeSecond: null,
  parentNameFirst: null,
  parentNameSecond: null,
  formData: null,
  isMobile: false,
  priceInfo: null,
  priceNotExists: false,
  prices: {},
  invoiceData: {},
  paymentMethodData: null,
  formSubmitted: false,
  priceNotExistsForSecondForm: null,
  formErrors: {},
  isFormDetailsEdit: false,
  customer: null,
  inlineForm: false,
  newLpForm: false,
  couponCode: '',
  validatedCouponData: {
    success: false
  },
  errorSend: false,
  tempBnr: '',
  reasonOptions: [
    'Privatumzug',
    'Firmenumzug',
    'Event / Veranstaltung (Be- und Entladung)',
    'Wohnungsauflösung',
    'Küchenlieferung / Möbellieferung',
    'Geschäftsauflösung',
    'Räumung',
    'Containeraufstellung',
    'Sperrmüllentsorgung',
    'Dreharbeiten',
    'Baumpflege',
    'Baustelle (Be- und Entladung)',
    'Heizöllieferung',
    'Gullyreinigung',
    'Kanalsanierung'
  ],
  branchesOptions: [],
  fromUrl: '',
  showIkModal: false,
  showObModal: false
};

const globalAppStore = {
  state: initialState,

  mutations: {
    SET_NEXT_STEP: (state, step) => {
      state.step = step;
    },
    SET_FORM_DATA: (state, formData) => {
      state.formData = formData;
    },
    SET_INVOICE_DATA: (state, invoiceData) => {
      state.invoiceData = invoiceData;
    },
    SET_FORM_ERROR: (state, formErrors) => {
      state.formErrors = formErrors;
    },
    SET_FORM_SUBMITTED: (state, formSubmitted) => {
      state.formSubmitted = formSubmitted;
    },
    SET_IS_MOBILE: (state, isMobile) => {
      state.isMobile = isMobile;
    },
    SET_PRICE_INFO: (state, priceInfo) => {
      state.priceInfo = priceInfo;
    },
    SET_PRICE_INFO_FOR_SECOND_FORM: (state, priceInfo) => {
      const newPriceInfo = cloneDeep(state.priceInfo);
      newPriceInfo.secondFormPrice = priceInfo;
      state.priceInfo = newPriceInfo;
    },

    SET_PRICE_NOT_EXISTS: (state, existsPrice) => {
      state.priceNotExists = existsPrice;
    },

    SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM: (state, existsPrice) => {
      state.priceNotExistsForSecondForm = existsPrice;
    },

    SET_TOTAL_PRICE: (state, totalPrice) => {
      state.prices = totalPrice;
    },
    SET_FORM_DETAILS_EDIT: (state, isFormDetailsEdit) => {
      state.isFormDetailsEdit = isFormDetailsEdit;
    },
    SET_SELECTION_POPUP: (state, selectionBool) => {
      state.selectionPopup = selectionBool;
    },
    SET_SELECTION_POPUP_ITEMS: (state, items) => {
      state.selectionPopupItems = items;
    },
    SET_SELECTION_POPUP_ZIPID: (state, id) => {
      state.selectionPopupZipId = id;
    },
    SET_SELECTION_POPUP_ZIPID_SECOND: (state, id) => {
      state.selectionPopupZipIdSecond = id;
    },
    SET_SELECTION_POPUP_LEVEL: (state, level) => {
      state.selectionPopupLevel = level;
    },
    SET_SELECTION_ZIPCODE_FIRST: (state, zip) => {
      state.selectionZipCodeFirst = zip;
    },
    SET_SELECTION_ZIPCODE_SECOND: (state, zip) => {
      state.selectionZipCodeSecond = zip;
    },
    SET_PARENT_NAME_FIRST: (state, name) => {
      state.parentNameFirst = name;
    },
    SET_PARENT_NAME_SECOND: (state, name) => {
      state.parentNameSecond = name;
    },

    RESET_ALL_STATES: state => {
      state.formData = null;
      state.isMobile = false;
      state.priceInfo = null;
      state.priceNotExists = false;
      state.prices = {};
      state.invoiceData = {};
      state.formSubmitted = false;
      state.priceNotExistsForSecondForm = null;
      state.formErrors = {};
      state.isFormDetailsEdit = false;
      state.step = 1;
      state.paymentMethodData = null;
      state.couponCode = '';
      state.validatedCouponData = { success: false };
      state.errorSend = false;
      state.tempBnr = '';
      state.reasonOptions = [];
      state.selectionPopup = false;
      state.selectionPopupItems = [];
      state.selectionPopupZipId = null;
      state.selectionPopupZipIdSecond = null;
      state.selectionPopupLevel = 1;
      state.selectionZipCodeFirst = null;
      state.selectionZipCodeSecond = null;
      state.parentNameFirst = null;
      state.parentNameSecond = null;
    },

    SET_CUSTOMER: (state, customerData) => {
      state.customer = customerData;
    },
    SET_PAYMENT_METHOD: (state, paymentMethodData) => {
      state.paymentMethodData = paymentMethodData;
    },
    SET_INLINE_FORM: (state, data) => {
      state.inlineForm = data;
    },
    SET_NEW_LP_FORM: (state, data) => {
      state.newLpForm = data;
    },
    SET_COUPON_CODE: (state, data) => {
      state.couponCode = data;
    },
    SET_VALIDATED_COUPON_DATA: (state, data) => {
      state.validatedCouponData = data;
    },
    SET_ERROR_SEND: (state, data) => {
      state.errorSend = data;
    },
    SET_TEMP_BNR: (state, data) => {
      state.tempBnr = data;
    },
    SET_REASON_OPTIONS: (state, reasonData) => {
      state.reasonOptions = reasonData;
    },
    SET_BRANCHES_OPTIONS: (state, reasonData) => {
      state.branchesOptions = reasonData;
    },
    SET_FROM_URL: (state, url) => {
      state.fromUrl = url;
    },
    SET_SHOW_IK_MODAL: (state, data) => {
      state.showIkModal = data;
    },
    SET_SHOW_OB_MODAL: (state, data) => {
      state.showObModal = data;
    }
  },
  actions: {
    getPriceInfoAction: async ({ dispatch, commit, getters }, { zipcode, priceForSecondForm }) => {
      try {
        let zipWithIdUrl = '';
        let zipWithId = null;
        if (priceForSecondForm) {
          zipWithId = getters.selectionPopupZipIdSecond;
          commit('SET_SELECTION_ZIPCODE_SECOND', zipcode);
        } else {
          zipWithId = getters.selectionPopupZipId;
          commit('SET_SELECTION_ZIPCODE_FIRST', zipcode);
        }
        if (zipWithId) {
          zipWithIdUrl = '&zipid=' + zipWithId;
        }

        let zipLeveldUrl = '';
        let popupLevel = getters.selectionPopupLevel;
        if (popupLevel) {
          zipLeveldUrl = '&ziplevel=' + popupLevel;
        }

        const response = await axios.get(
          appConfig.apiUrl + 'form/info?zipcode=' + zipcode + zipWithIdUrl + zipLeveldUrl
        );
        if (response.data) {
          let zipResponse = response.data;

          if (priceForSecondForm) {
            if (zipResponse.selection === true) {
              commit('SET_SELECTION_POPUP_ITEMS', zipResponse.items);
              commit('SET_SELECTION_POPUP', true);
            } else {
              commit('SET_PARENT_NAME_SECOND', zipResponse.items.parent_stadt);
              commit('SET_SELECTION_POPUP_ZIPID_SECOND', zipResponse.items.id);
              commit('SET_PRICE_INFO_FOR_SECOND_FORM', zipResponse.items);
              
              // Check if ZIP code is invalid (no ID)
              if (!zipResponse.items.id) {
                commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', true);
                return;
              }
              
              // Check if price contains #Preis (needs daily price inquiry)
              if (zipResponse.items.genehmigung_brutto && zipResponse.items.genehmigung_brutto.indexOf('#Preis') !== -1) {
                commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', true);
                return;
              }
              
              // Check if price is 0 or null - should trigger validation mechanism
              const priceFields = [
                zipResponse.items.genehmigung_brutto,
                zipResponse.items.beidseitig_aufstellung,
                zipResponse.items.grundpreis_brutto
              ];
              
              const hasZeroPrice = priceFields.some(price => {
                if (price === null || price === undefined) return false;
                const numericPrice = parseFloat(price);
                return numericPrice === 0;
              });
              
              if (hasZeroPrice) {
                commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', true);
                return;
              }
            }
            // calculate price again
            dispatch('getTotalPriceAction');
            commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', false);
            return;
          }

	          if (zipResponse.selection !== true && zipResponse.items.genehmigung_brutto.indexOf('#Preis') !== -1) {
            commit('SET_PRICE_INFO_FOR_SECOND_FORM', {});
            commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', true);
            return;
          }
          

          if (zipResponse.selection === true) {
            commit('SET_SELECTION_POPUP_ITEMS', zipResponse.items);
            commit('SET_SELECTION_POPUP', true);
	    commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', false);
            commit('SET_PRICE_NOT_EXISTS', false);
          } else {
            commit('SET_PARENT_NAME_FIRST', zipResponse.items.parent_stadt);
            commit('SET_SELECTION_POPUP_ZIPID', zipResponse.items.id);
            commit('SET_PRICE_INFO', zipResponse.items);
            commit('SET_PRICE_NOT_EXISTS', false);
	    commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', false);
            // this is only for inline-form, to navigate through link
            commit('SET_SELECTION_POPUP_LEVEL', zipResponse.items.level);
	    return;
          }


        }
      } catch (e) {
        if (priceForSecondForm) {
          commit('SET_PRICE_INFO_FOR_SECOND_FORM', {});
          commit('SET_PRICE_NOT_EXISTS_FOR_SECOND_FORM', true);
          return;
        }

        commit('SET_PRICE_INFO', {});
        commit('SET_PRICE_NOT_EXISTS', true);
      }
    },

    getTotalPriceAction: async ({ commit, getters }) => {
      try {
        let customerData = null;
        if (getters.customer) {
          customerData = {
            id: getters.customer.id,
            bsr: getters.customer.bsr
          };
        }

        const response = await axios.post(appConfig.apiUrl + 'form/price', {
          ...getters.formData,
          ...getters.priceInfo,
          customer: customerData,
          coupon: getters.validatedCouponData,
          zipWithId: getters.selectionPopupZipId,
          zipWithIdSecond: getters.selectionPopupZipIdSecond
        });
        commit('SET_TOTAL_PRICE', response.data);
      } catch (e) {
        commit('SET_TOTAL_PRICE', null);
      }
    },

    resetStoreAction: async ({ commit, getters }) => {
      commit('RESET_ALL_STATES');
    },

    postOrderAction: async ({ commit, getters }, onSuccess) => {
      try {
        let paymentMethod = getters.formData.paymentMethod ? getters.formData.paymentMethod : PAYMENT_TYPES.VORKASSE;

        let secondForm = {};
        if (getters.formData.secondForm && getters.formData.secondForm.zipCode) {
          secondForm = {
            dateFrom2: getters.formData.secondForm.dateFrom.replaceAll('.', '-'),
            dateTo2: getters.formData.secondForm.dateTo.replaceAll('.', '-'),
            length2: getters.formData.secondForm.length,
            oppositeStreet2: getters.formData.secondForm.oppositeStreet,
            reason2: getters.formData.secondForm.reason,
            street2: getters.formData.secondForm.street,
            streetNr2: getters.formData.secondForm.streetNr,
            timeEnd2: getters.formData.secondForm.timeEnd,
            timeStart2: getters.formData.secondForm.timeStart,
            zipCode2: getters.formData.secondForm.zipCode,
            zipWithIdSecond: getters.selectionPopupZipIdSecond
          };
        }
        const response = await axios.post(appConfig.apiUrl + 'order', {
          ...getters.formData,
          dateFrom: getters.formData.dateFrom.replaceAll('.', '-'),
          dateTo: getters.formData.dateTo.replaceAll('.', '-'),
          ...getters.invoiceData,
          ...secondForm,
          paymentMethod,
          coupon: { ...getters.prices.coupon },
          tempBnr: getters.tempBnr,
          zipWithId: getters.selectionPopupZipId,
          fromUrl: getters.fromUrl
        });

        if (typeof onSuccess === 'function') {
          if (response.data.status) {
            onSuccess({
              status: response.data.status,
              redirectUrl: response.data.url,
              paymentMethod: response.data.paymentMethod,
              orderId: response.data.orderId,
              price: response.data.price
            });
          } else {
            onSuccess({ status: false, redirectUrl: null, paymentMethod: null, orderId: null });
          }
        }
      } catch (e) {
        if (typeof onSuccess === 'function') {
          onSuccess({ status: false, redirectUrl: null, paymentMethod: null, orderId: null });
        }
      }
    },

    resetPriceInfoAction: ({ commit }) => {
      commit('SET_PRICE_INFO', null);
      commit('SET_SELECTION_POPUP', false);
    },

    setExistsPriceAction: ({ commit }, existsPrice) => {
      commit('SET_PRICE_NOT_EXISTS', existsPrice);
    },

    setFormDataAction: ({ commit, dispatch }, formData) => {
      commit('SET_FORM_DATA', formData);
      dispatch('getTotalPriceAction');
    },

    updateFormDataAction: ({ commit, dispatch, getters }, newData) => {
      const formData = { ...getters.formData, ...newData };
      commit('SET_FORM_DATA', formData);
      dispatch('getTotalPriceAction');
    },

    updateFormErrorAction: ({ commit, getters }, newData) => {
      const formErrors = { ...getters.formErrors, ...newData };
      commit('SET_FORM_ERROR', formErrors);
    },

    setInvoiceDataAction: ({ commit, dispatch }, invoiceData) => {
      commit('SET_INVOICE_DATA', invoiceData);
    },

    setFormSubmittedAction: ({ commit, dispatch }, formSubmitted) => {
      commit('SET_FORM_SUBMITTED', formSubmitted);
    },

    setIsFormDetailsEditAction: ({ commit, dispatch }, isFormDetailsEdit) => {
      commit('SET_FORM_DETAILS_EDIT', isFormDetailsEdit);
    },

    updateInvoiceDataAction: ({ commit, dispatch, getters }, newData) => {
      const invoiceData = { ...getters.invoiceData, ...newData };
      commit('SET_INVOICE_DATA', invoiceData);
    },

    updateSecondFormDataAction: ({ commit, dispatch, getters }, newData) => {
      const clonedFormData = cloneDeep(getters.formData);
      clonedFormData.secondForm = { ...clonedFormData.secondForm, ...newData };
      commit('SET_FORM_DATA', clonedFormData);
      dispatch('getTotalPriceAction');
    },

    setIsMobileAction: ({ commit, getters }) => {
      const isMobile = isMobilePhone();
      if (isMobile) {
        commit('SET_IS_MOBILE', true);
        return;
      }
      if (window.innerWidth <= BREAKPOINT_MOBILE) {
        if (getters.isMobile === false) {
          commit('SET_IS_MOBILE', true);
        }
      }
      window.onresize = () => {
        if (window.innerWidth <= BREAKPOINT_MOBILE) {
          if (getters.isMobile === false) {
            commit('SET_IS_MOBILE', true);
          }
        } else {
          if (getters.isMobile) {
            commit('SET_IS_MOBILE', false);
          }
        }
      };
    },

    getCustomerAction: async ({ commit, dispatch, state }) => {
      try {
        const response = await axios.get(appConfig.hostUrl + '/index/get-customer');
        commit('SET_CUSTOMER', response.data);

        if (response.data) {
          let customerType = CUSTOMER_TYPES.PRIVATE;
          if (response.data.kunden_art == 'firma') {
            customerType = CUSTOMER_TYPES.COMPANY;
          }

          let gender = null;
          if (response.data.anrede == 'herr') {
            gender = CUSTOMER_SEX_TYPES.male;
          } else if (response.data.anrede == 'frau') {
            gender = CUSTOMER_SEX_TYPES.female;
          } else if (response.data.anrede == 'divers') {
            gender = CUSTOMER_SEX_TYPES.divers;
          } else if (response.data.anrede == 'firma') {
            gender = CUSTOMER_SEX_TYPES.company;
          }

          let invoiceNote = '';
          let invoiceAgb = false;
          if (response.data.bsr) {
            invoiceNote = 'Betriebsstelle: ' + response.data.vorname + ' \nName d. Mitarbeiters: \n';
            invoiceAgb = true;
          } else if (response.data.kuchenaktuell) {
            invoiceAgb = true;
          }

          let customerInvoiceData = {
            customerType: customerType,
            firmName: response.data.firmenname,
            firmBranch: response.data.branch,
            birthDate: response.data.birthdate,
            gender: gender,
            zip: response.data.plz,
            firstName: response.data.vorname,
            lastName: response.data.name,
            strasse: response.data.strasse_nr,
            city: response.data.stadt,
            phone: response.data.tel,
            mobile: response.data.mobile,
            fax: response.data.fax,
            email: response.data.email,
            note: invoiceNote,
            agb: invoiceAgb
          };

          dispatch('updateInvoiceDataAction', customerInvoiceData);

          let paymentMethodData = null;
          if (response.data.zahlungsart == 'Einzugsermächtigung') {
            paymentMethodData = PAYMENT_TYPES.EINZUG;
          } else if (response.data.zahlungsart == 'Überweisung') {
            paymentMethodData = PAYMENT_TYPES.VORKASSE;
          } else if (response.data.zahlungsart == 'PayPal') {
            paymentMethodData = PAYMENT_TYPES.PAYPAL;
          } else if (response.data.zahlungsart == 'Sofortüberweisung') {
            paymentMethodData = PAYMENT_TYPES.KLARNA;
          }
          commit('SET_PAYMENT_METHOD', paymentMethodData);
        }
      } catch (e) {
        commit('SET_CUSTOMER', null);
        commit('SET_PAYMENT_METHOD', null);
      }
    },

    postCouponAction: async ({ commit, getters }, onSuccess) => {
      try {
        const response = await axios.post(appConfig.apiUrl + 'form/coupon', {
          couponCode: getters.couponCode,
          totalPrice: getters.prices.total
        });
        if (typeof onSuccess === 'function') {
          onSuccess(response.data);
        }
      } catch (e) {
        //console.log('on error', e);
      }
    },

    getReasonsAction: async ({ commit, dispatch, state }) => {
      try {
        const response = await axios.get(appConfig.apiUrl + 'form/reasons');
        if (response.data) {
          commit('SET_REASON_OPTIONS', response.data);
        }
      } catch (e) {
        //console.log('on error', e);
      }
    },

    getBranchesAction: async ({ commit, dispatch, state }) => {
      try {
        const response = await axios.get(appConfig.apiUrl + 'form/branches');
        if (response.data) {
          commit('SET_BRANCHES_OPTIONS', response.data);
        }
      } catch (e) {
        //console.log('on error', e);
      }
    },

    getPppTokenAction: async ({ commit, getters }, onSuccess) => {
      try {
        const response = await axios.post(appConfig.apiUrl + 'paypal', {
          price: getters.prices.total
        });
        if (typeof onSuccess === 'function') {
          onSuccess(response.data);
        }
      } catch (e) {
        //console.log('on error', e);
        if (typeof onSuccess === 'function') {
          onSuccess({ status: false });
        }
      }
    }
  },
  getters: {
    priceInfo: state => state.priceInfo,
    prices: state => state.prices,
    priceNotExists: state => state.priceNotExists,
    priceNotExistsForSecondForm: state => state.priceNotExistsForSecondForm,
    step: state => state.step,
    formData: state => state.formData,
    invoiceData: state => state.invoiceData,
    isMobile: state => state.isMobile,
    formSubmitted: state => state.formSubmitted,
    formErrors: state => state.formErrors,
    isFormDetailsEdit: state => state.isFormDetailsEdit,
    customer: state => state.customer,
    paymentMethodData: state => state.paymentMethodData,
    inlineForm: state => state.inlineForm,
    newLpForm: state => state.newLpForm,
    couponCode: state => state.couponCode,
    validatedCouponData: state => state.validatedCouponData,
    errorSend: state => state.errorSend,
    tempBnr: state => state.tempBnr,
    reasonOptions: state => state.reasonOptions,
    branchesOptions: state => state.branchesOptions,
    selectionPopup: state => state.selectionPopup,
    selectionPopupItems: state => state.selectionPopupItems,
    selectionPopupZipId: state => state.selectionPopupZipId,
    selectionPopupZipIdSecond: state => state.selectionPopupZipIdSecond,
    selectionPopupLevel: state => state.selectionPopupLevel,
    selectionZipCodeFirst: state => state.selectionZipCodeFirst,
    selectionZipCodeSecond: state => state.selectionZipCodeSecond,
    parentNameFirst: state => state.parentNameFirst,
    parentNameSecond: state => state.parentNameSecond,
    fromUrl: state => state.fromUrl,
    showIkModal: state => state.showIkModal,
    showObModal: state => state.showObModal
  }
};

export default globalAppStore;
